import './Side-bar.scss'

import { useState } from 'react'
import { Link } from 'react-router-dom'

import LocalStorage from '../../services/LocalStorage.service'
import SecurityService from '../../services/security.service'

import logo from '../../assets/images/logo/logo.png'
import logoHorizontal from '../../assets/images/logo/logo_name.png'
import MenuItem from './components/MenuItem'
import { menuData } from './utils/menuData'

const SideBar = () => {
  const [menuToggled, setMenuToggled] = useState(false)
  const [toggleLogout, setToggleLogout] = useState(false)

  // FIXME: CORRIGIR PROTEÇÃO DE ROTAS
  const logout = () => {
    LocalStorage.clear()
    window.location.replace('/login')
  }

  return (
    <div>
      <div className='nav-margin hidden-md-up'></div>
      <div
        className='overlay'
        id='overlay'
        onClick={() => setMenuToggled((prev) => !prev)}
        style={{
          animation: menuToggled ? 'showup .35s' : 'dismiss .35s',
          display: menuToggled ? 'block' : 'none'
        }}
      ></div>

      {/* Mobile */}
      <nav className='navbar-ifa fixed-top hidden-md-up'>
        <button
          className='navbar-toggler navbar-toggler-left'
          type='button'
          onClick={() => setMenuToggled((prev) => !prev)}
        >
          <i className='fa fa-bars'></i>
        </button>
        <div className='navbar-brand'>
          <img
            className='w'
            src={logo}
            alt=''
          />
          <img
            className='h'
            src={logoHorizontal}
            alt=''
          />
        </div>
        <div
          className='sidemenu'
          id='sidemenu'
          style={{
            margin: menuToggled ? 0 : '0 0 0 -256px'
          }}
        >
          <div className='nav-btn borderless'>
            <i className='fa fa-user'></i>
            <label>Admin IFA</label>
          </div>

          {menuData.map((item) => (
            <MenuItem
              key={item.link}
              label={item.label}
              icon={item.icon}
              link={item.link}
              isMobile
            />
          ))}

          {SecurityService.isMaster() && (
            <Link to='/trash'>
              <div
                className='nav-btn borderless-b'
                onClick={() => setMenuToggled((prev) => !prev)}
              >
                <i className='fa fa-trash' />
                <label>Lixeira</label>
              </div>
            </Link>
          )}

          <div
            className='nav-btn logout'
            onClick={logout}
          >
            <i className='fa fa-power-off'></i>
            <label>Sair</label>
          </div>
        </div>
      </nav>

      {/* Desktop */}
      <div id='sidebar'>
        <div className='menu-logo'>
          <img
            className='w'
            src={logo}
            alt=''
          />
          <img
            className='h'
            src={logoHorizontal}
            alt=''
          />
        </div>
        <div className='sidebar-item-wrappers'>
          <div
            onClick={() => setToggleLogout((prev) => !prev)}
            data-toggle='collapse'
            aria-expanded='false'
            className='menu-item menu-item-has-items'
          >
            <div className='icon'>
              <i className='fa fa-user'></i>
            </div>
            <label>
              Admin IFA
              <i
                className='fa fa-caret-down'
                aria-hidden='true'
              ></i>
            </label>
          </div>
          <div
            id='sidebar-logout'
            className='collapse'
            style={{
              display: toggleLogout ? 'block' : 'none'
            }}
          >
            <div
              className='menu-item sub-item'
              onClick={logout}
            >
              <div className='icon'>
                <i className='fa fa-power-off'></i>
              </div>
              <label>Sair</label>
            </div>
          </div>

          {menuData.map((item) => (
            <MenuItem
              key={item.link}
              label={item.label}
              icon={item.icon}
              link={item.link}
              isMobile={false}
            />
          ))}

          {SecurityService.isMaster() && (
            <Link to='/trash'>
              <div className='menu-item'>
                <div>
                  <i className='fa fa-trash'></i>
                </div>
                <label>Lixeira</label>
              </div>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default SideBar
